"use client";

import { useState } from "react";
import { MediaCard } from "./Mediacard";
import { MediaLightbox } from "./Medialightbox";

const imageWrapperClasses =
  "relative overflow-hidden w-full h-[120px] sm:h-[150px] md:h-[190px] lg:h-[300px]";

export default function MediaGallery({ media = [] }) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleMediaClick = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  return (

    <section className="w-full bg-white">
      <div className="mt-4">
        <div
          className="
        grid gap-4 sm:gap-5 w-full
        grid-cols-2 md:grid-cols-4
        auto-rows-fr
      "
        >
          {/* FIRST BIG IMAGE (SQUARE) */}
          {media[0] && (
            <div className="col-span-2 row-span-2 aspect-square overflow-hidden rounded-lg">
              <MediaCard item={media[0]} onClick={() => handleMediaClick(0)} />
            </div>
          )}

          {/* REST IMAGES */}
          {media.slice(1, 9).map((item, index) => (
            <div
              key={index}
              className="aspect-square overflow-hidden rounded-lg"
            >
              <MediaCard
                item={item}
                onClick={() => handleMediaClick(index + 1)}
              />
            </div>
          ))}

          {/* LAST BIG IMAGE */}
          {media[9] && (
            <div className="col-span-2 row-span-2 aspect-square overflow-hidden rounded-lg">
              <MediaCard item={media[9]} onClick={() => handleMediaClick(9)} />
            </div>
          )}
        </div>
      </div>

      <MediaLightbox
        items={media}
        currentIndex={currentIndex}
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        onNavigate={setCurrentIndex}
      />
    </section>

  );
}
